import { useUIContext } from 'lib/context/UIContext/UIContext';
import { cn } from 'lib/helpers/utility';

import Checkbox from 'components/shared/Checkbox/Checkbox';
import Icon from 'components/shared/Icon/Icon';

const Header = ({
  icon,
  iconSize,
  iconColor,
  variant,
  title,
  message,
  handleClose,
  dontShowAgain,
  setDontShowAgain,
  showDontShowThisMessageAgain
}) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  return (
    <div className="flex flex-col gap-5 border-0 border-b border-solid border-neutral-200 px-5 pb-5 pt-6">
      <div className="flex items-start justify-between gap-5">
        {icon && !isMobile && (
          <div
            className={cn(
              'flex h-12 w-12 shrink-0 items-center justify-center rounded-full',
              `bg-${variant}-50`
            )}>
            <Icon icon={icon} size={iconSize} color={iconColor || variant} />
          </div>
        )}
        <div className="flex w-full justify-between gap-8">
          <div className="flex flex-col gap-1.5">
            <h3 className="text-base font-600 leading-6 text-neutral-800">{title}</h3>
            {message && (
              <p className="whitespace-pre-line text-sm leading-[22px] text-neutral-700">
                {message}
              </p>
            )}
          </div>
          <div
            data-qa="close-icon"
            className="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center hover:bg-neutral-50"
            onClick={handleClose}>
            <Icon icon="close-linear" size={20} />
          </div>
        </div>
      </div>
      {showDontShowThisMessageAgain && (
        <Checkbox
          label="Don't show this message again"
          innerLabelClassName="gap-[6px]"
          labelTextColor="text-xs font-500 text-neutral-700"
          size={16}
          isChecked={dontShowAgain}
          onChange={() => setDontShowAgain(!dontShowAgain)}
        />
      )}
    </div>
  );
};

export default Header;
